import { createI18nInstance } from '@bit/amazingdesign.react-redux-mui-starter.i18n'

export const i18n = createI18nInstance({
  lng: 'pl'
})

export default i18n